export const camelCaseToKebabCase = (str) =>
  str.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);

export const stringHideFormatter = (str, type) => {
  let strArr = str.split('');

  const separatorIndex = type === 'email' ? str.indexOf('@') : str.replaceAll(' ', '').length;
  const midName = Math.floor(separatorIndex / (type === 'email' ? 3 : 2));
  strArr.splice(midName, separatorIndex - midName, '*'.repeat(separatorIndex - midName));
  return strArr.join('');
};

export const formatEnumString = (str) => {
  return str
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/(^|\s)\S/g, (match) => match.toUpperCase());
};
